module.exports = __webpack_public_path__ + "static/media/helltaker.c32a2392.jpg";